import React from "react";
import { ExportReportType, REPORT_EXPORTS } from "@sscs/types";
import { Dialog, Form, Menu } from "@sscs/ui";
import { REPORT_EXPORT_HELPER_LABEL } from "Constants";
import { SHARED_REPORT_LINK_EXPIRY_DAYS } from "../../../../../utils";
import styles from "./restrictionsStep.module.scss";

const CheckboxLabel = ({
  report,
}: {
  report: ExportReportType;
}): React.JSX.Element => {
  return (
    <>
      {REPORT_EXPORTS[report]} Export{" "}
      <span className={styles["checkbox-label-helper"]}>
        ({REPORT_EXPORT_HELPER_LABEL[report]})
      </span>
    </>
  );
};

const RestrictionsStep = (): React.JSX.Element => {
  return (
    <>
      <Dialog.Section>
        <Dialog.Section.Title>Link expiration</Dialog.Section.Title>
        <Dialog.Section.Content>
          <Form.DropdownMenu
            id="expires-in"
            name="expires_in"
            variant="outlined"
            isFullWidth
          >
            {SHARED_REPORT_LINK_EXPIRY_DAYS.map((days) => (
              <Menu.Item
                key={`${days}-expiry-days`}
                id={`${days}-expiry-days`}
                value={days}
              >
                {days.toLocaleString()} day{days > 1 ? "s" : ""}
              </Menu.Item>
            ))}
          </Form.DropdownMenu>
        </Dialog.Section.Content>
      </Dialog.Section>
      <Dialog.Section>
        <Dialog.Section.Title>Access restrictions</Dialog.Section.Title>
        <Dialog.Section.Description>
          To control access to the report, set optional restrictions.
        </Dialog.Section.Description>
        <Dialog.Section.Content>
          <Form.Checkbox
            name="package_download_enabled"
            label="Package download"
            helperText="Package downloads will spend your Portal download capacity."
            className={styles["form-checkbox"]}
          />
          <div className={styles["form-checkboxes"]}>
            <Form.Checkbox
              name="cyclonedx_export_enabled"
              label={<CheckboxLabel report="cycloneDX" />}
              className={styles["form-checkbox"]}
            />
            <Form.Checkbox
              name="spdx_export_enabled"
              label={<CheckboxLabel report="spdx" />}
              className={styles["form-checkbox"]}
            />
            <Form.Checkbox
              name="sarif_export_enabled"
              label={<CheckboxLabel report="sarif" />}
              className={styles["form-checkbox"]}
            />
            <Form.Checkbox
              name="rl_cve_export_enabled"
              label={<CheckboxLabel report="cve" />}
              className={styles["form-checkbox"]}
            />
            <Form.Checkbox
              name="rl_uri_export_enabled"
              label={<CheckboxLabel report="uri" />}
              className={styles["form-checkbox"]}
            />
            <Form.Checkbox
              name="rl_json_export_enabled"
              label={<CheckboxLabel report="json" />}
              className={styles["form-checkbox"]}
            />
            <Form.Checkbox
              name="rl_safe_export_enabled"
              label={<CheckboxLabel report="safe" />}
              className={styles["form-checkbox"]}
            />
            <Form.Checkbox
              name="rl_summary_pdf_export_enabled"
              label={<CheckboxLabel report="summaryPdf" />}
              className={styles["form-checkbox"]}
            />
          </div>
        </Dialog.Section.Content>
      </Dialog.Section>
      <Dialog.Section>
        <Dialog.Section.Title>Password protection</Dialog.Section.Title>
        <Dialog.Section.Content>
          <Form.Checkbox
            name="password_protected"
            label="Protect with auto-generated password"
            className={styles["form-checkbox"]}
          />
        </Dialog.Section.Content>
      </Dialog.Section>
    </>
  );
};

export default RestrictionsStep;
